import { Injectable, Inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Http } from '@angular/http';

import {
  AuthenticationDetails,
  CognitoRefreshToken,
  CognitoUser,
  CognitoUserAttribute,
  CognitoUserPool,
  CognitoUserSession
} from 'amazon-cognito-identity-js';

import * as AWS from 'aws-sdk/global';
import * as awsservice from 'aws-sdk/lib/service';
import * as STS from 'aws-sdk/clients/sts';
import * as S3 from 'aws-sdk/clients/s3';
import * as CognitoIdentity from 'aws-sdk/clients/cognitoidentity';
import { CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY_PROVIDER_FACTORY } from '@angular/cdk/overlay/typings/overlay-directives';
import { CodeBuild, CodeCommit } from 'aws-sdk';

export interface CognitoCallback {
  cognitoCallback(message: string, result: any): void;
}

export interface LoggedInCallback {

  isLoggedIn(message: string, loggedIn: boolean): void;
}

export interface Callback {
  callback(): void;
  callbackWithParam(result: any): void;
}

export declare class ExtendedCognitoUser extends CognitoUser {

  public forgetDevice(callbacks: { onSuccess: (success: string) => void, onFailure: (err: Error) => void }): any;

  public listDevices(username: number, paginationToken: string,
    callbacks: { onSuccess: (success: string) => void, onFailure: (err: Error) => void }): any;
}


@Injectable()
export class CognitoUtil {

  constructor() {
  }

  public static _REGION = environment.region;

  public static _IDENTITY_POOL_ID = environment.identityPoolId;
  public static _USER_POOL_ID = environment.userPoolId;
  public static _CLIENT_ID = environment.clientId;

  public static _POOL_DATA: any = {
    UserPoolId: CognitoUtil._USER_POOL_ID,
    ClientId: CognitoUtil._CLIENT_ID
  };

  public cognitoCreds: AWS.CognitoIdentityCredentials;

  getUserPool() {
    if (environment.loginKey) {
      CognitoUtil._POOL_DATA.endpoint = environment.loginKey;
    }
    return new CognitoUserPool(CognitoUtil._POOL_DATA);
  }

  getCurrentUser() {
    return this.getUserPool().getCurrentUser();
  }

  setCognitoCreds(creds: AWS.CognitoIdentityCredentials) {
    this.cognitoCreds = creds;
  }

  getCognitoCreds() {
    return this.cognitoCreds;
  }

  buildCognitoCreds(idTokenJwt: string) {
    let url = 'cognito-idp.' + CognitoUtil._REGION.toLowerCase() + '.amazonaws.com/' + CognitoUtil._USER_POOL_ID;
    if (environment.loginKey) {
      url = environment.loginKey + '/' + CognitoUtil._USER_POOL_ID;
    }
    const logins: CognitoIdentity.LoginsMap = {};
    logins[url] = idTokenJwt;
    const params = {
      IdentityPoolId: CognitoUtil._IDENTITY_POOL_ID, /* required */
      Logins: logins
    };
    const serviceConfigs: awsservice.ServiceConfigurationOptions = {};
    if (environment.loginKey) {
      serviceConfigs.endpoint = environment.loginKey;
    }
    const creds = new AWS.CognitoIdentityCredentials(params, serviceConfigs);
    this.setCognitoCreds(creds);
    return creds;
  }

  getCognitoIdentity(): string {
    return this.cognitoCreds.identityId;
  }

  getAccessToken(callback: Callback): void {
    if (callback == null) {
      callback.callbackWithParam('ERROR');
    }

    if (this.getCurrentUser() != null) {
      this.getCurrentUser().getSession(function (err, session) {
        if (err) {
          callback.callbackWithParam(null);
        }

        else {
          if (session.isValid()) {
            callback.callbackWithParam(session.getAccessToken().getJwtToken());
          }
        }
      });
    } else {
      callback.callbackWithParam(null);
    }
  }

  getIdToken(callback: CognitoCallback): void {
    let cognitoUser = this.getCurrentUser();
    cognitoUser.getSession(function (err, session) {
      callback.cognitoCallback('id token', session.getAccessToken().getJwtToken());
    });
  }

  getRefreshToken(callback: Callback): void {
    if (callback == null) {
      callback.callbackWithParam('ERROR');
    }
    if (this.getCurrentUser() != null) {
      this.getCurrentUser().getSession(function (err, session) {
        if (err) {
          callback.callbackWithParam(null);
        }

        else {
          if (session.isValid()) {
            callback.callbackWithParam(session.getRefreshToken());
          }
        }
      });
    } else {
      callback.callbackWithParam(null);
    }
  }

  refresh(): void {
    this.getCurrentUser().getSession(function (err, session) {

    });
  }

  authenticate(username: string, password: string, callback: CognitoCallback) {

    let authenticationData = {
      Username: username,
      Password: password,
    };

    let authenticationDetails = new AuthenticationDetails(authenticationData);

    let userData = {
      Username: username,
      Pool: this.getUserPool()
    };

    let cognitoUser = new CognitoUser(userData);
    let self = this;

    cognitoUser.authenticateUser(authenticationDetails, {

      newPasswordRequired: function (userAttributes, requiredAttributes) {
        callback.cognitoCallback(`User needs to set password.`, null);
      },

      onSuccess: function (result) {

        let creds = self.buildCognitoCreds(result.getIdToken().getJwtToken());

        AWS.config.credentials = creds;

        let clientParams: any = {};
        if (environment.sts_endpoint) {
          clientParams.endpoint = environment.sts_endpoint;
        }

        let sts = new STS(clientParams);
        sts.getCallerIdentity(function (err, data) {
          callback.cognitoCallback('loginSuccess', result);
        });

      },

      onFailure: function (err) {
        callback.cognitoCallback(err.message, null);
      },

      mfaRequired: function (challengeName, challengeParameters) {
        callback.cognitoCallback('MFA', cognitoUser);
      }

    });
  }

  rememberDevice(callback: CognitoCallback) {
    let cognitoUser = this.getCurrentUser();

    cognitoUser.getSession(function (err, session) {

      // this gets tho stored token
      let test = session.getAccessToken().getJwtToken();
      test = test.split('.')[1].replace('-', '+').replace('_', '/');
      // this get the device key
      test = JSON.parse(window.atob(test)).device_key;

      // then you put the key in an object
      test = {
        deviceKey: test
      };

      /// finally you merge the key into the current user.
      cognitoUser = Object.assign(cognitoUser, test);

      cognitoUser.setDeviceStatusRemembered({
        onSuccess: function (result) {
          callback.cognitoCallback('deviceRemembered', result);
        },
        onFailure: function (err) {
          callback.cognitoCallback('failedToRemember', err);
        }
      });
    });
  }

  forgotPassword(username: string, callback: CognitoCallback) {
    let userData = {
      Username: username,
      Pool: this.getUserPool()
    };
    let cognitoUser = new CognitoUser(userData);

    cognitoUser.forgotPassword({
      onSuccess: function () {

      },
      onFailure: function (err) {
        callback.cognitoCallback(err.message, null);
      },
      inputVerificationCode() {
        callback.cognitoCallback('codeNeeded', null);
      }
    });
  }

  needToVerifySMS(callback: CognitoCallback) {

    let cognitoUser = this.getCurrentUser();

    if (cognitoUser != null) {

      let extendedUser = <ExtendedCognitoUser>this.getCurrentUser();

      extendedUser.getSession(function (err, session) {
        if (err) {
          return;
        }

        extendedUser.getAttributeVerificationCode('phone_number', {
          onSuccess: function () {

          },
          onFailure: function (err) {
            callback.cognitoCallback(err.message, null);
          },
          inputVerificationCode: function () {
            callback.cognitoCallback('SMSCode', null);
          }
        });

      });
    }

  }

  verifySMS(callback: CognitoCallback, code: string) {

    let cognitoUser = this.getCurrentUser();

    if (cognitoUser != null) {

      let extendedUser = <ExtendedCognitoUser>this.getCurrentUser();

      extendedUser.getSession(function (err, session) {
        if (err) {
          return;
        }

        extendedUser.verifyAttribute('phone_number', code, {
          onSuccess: function () {
            callback.cognitoCallback('SMSVerified', null);
          },
          onFailure: function (err) {
            callback.cognitoCallback(err.message, null);
          }
        });

      });
    }
  }

  confirmNewPassword(email: string, verificationCode: string, password: string, callback: CognitoCallback) {
    let userData = {
      Username: email,
      Pool: this.getUserPool()
    };

    let cognitoUser = new CognitoUser(userData);

    cognitoUser.confirmPassword(verificationCode, password, {
      onSuccess: function () {
        callback.cognitoCallback('passwordReset', null);
      },
      onFailure: function (err) {
        callback.cognitoCallback(err.message, null);
      }
    });
  }

  logout() {
    if (this.getCurrentUser()) {
      this.getCurrentUser().signOut();
    }
    else {
      return null;
    }

  }

  newPasswordRequired(username: string, currentPassword: string, newPassword: string, attributeList, callback: CognitoCallback) {

    let authenticationData = {
      Username: username,
      Password: currentPassword,
    };

    let authenticationDetails = new AuthenticationDetails(authenticationData);

    let userData = {
      Username: username,
      Pool: this.getUserPool()
    };

    let cognitoUser = new CognitoUser(userData);

    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: function (result) {
        // this should never happen....ever
        callback.cognitoCallback('failedReset', result);
      },
      onFailure: function (err) {
        callback.cognitoCallback(err.message, null);
      },
      newPasswordRequired: function (userAttributes, requiredAttributes) {
        cognitoUser.completeNewPasswordChallenge(newPassword, attributeList, {

          onSuccess: function (result) {
            callback.cognitoCallback('completeReset', result);
          },

          onFailure: function (err) {
            callback.cognitoCallback('failedReset', err);
          },

          mfaRequired: function (challengeName, challengeParameters) {
            callback.cognitoCallback('MFA', cognitoUser);
          }
        });
      }
    });
  }

  isAuthenticated(callback: LoggedInCallback) {
    if (callback == null) {
      callback.isLoggedIn('ERROR', false);
    }

    let cognitoUser = this.getCurrentUser();

    if (cognitoUser != null) {
      cognitoUser.getSession(function (err, session) {
        if (err) {
          callback.isLoggedIn(err, false);
        }
        else {
          callback.isLoggedIn(err, session.isValid());
        }
      });
    } else {
      callback.isLoggedIn('Cant retrieve the CurrentUser', false);
    }
  }

  register(user: any, callback: CognitoCallback): void {

    let poolData = {
      UserPoolId: environment.userPoolId,
      ClientId: environment.clientId
    };

    let userPool = new CognitoUserPool(poolData);

    let attributeList = [];

    attributeList.push(
      new CognitoUserAttribute({
        Name: 'email',
        Value: user.email
      })
    );

    attributeList.push(
      new CognitoUserAttribute({
        Name: 'custom:role',
        Value: user.role
      })
    );

    // attributeList.push(
    //   new CognitoUserAttribute({
    //     Name: 'custom:organization',
    //     Value: user.organization
    //   })
    // );

    attributeList.push(
      new CognitoUserAttribute({
        Name: 'phone_number',
        Value: user.phoneNumber
      })
    );

    attributeList.push(
      new CognitoUserAttribute({
        Name: 'middle_name',
        Value: user.middleName
      })
    );

    attributeList.push(
      new CognitoUserAttribute({
        Name: 'family_name',
        Value: user.lastName
      })
    );

    attributeList.push(
      new CognitoUserAttribute({
        Name: 'name',
        Value: user.firstName
      })
    );

    attributeList.push(
      new CognitoUserAttribute({
        Name: 'address',
        Value: user.address
      })
    );

    if(user.role == 'ATTORNEY'){
      attributeList.push(
        new CognitoUserAttribute({
          Name: 'custom:barNumber',
          Value: user.barNumber
        })
      );
      attributeList.push(
        new CognitoUserAttribute({
          Name: 'custom:lawFirm',
          Value: user.lawFirm
        })
      );
    }
    
    userPool.signUp(user.email, user.password, attributeList, null, function (err, result) {
      if (err) {
        callback.cognitoCallback('ERROR', err);
      }
      callback.cognitoCallback('SUCCESS', result.user);
    });

  }

  confirmRegistration(username: string, confirmationCode: string, callback: CognitoCallback): void {

    let userData = {
      Username: username,
      Pool: this.getUserPool()
    };

    let cognitoUser = new CognitoUser(userData);

    cognitoUser.confirmRegistration(confirmationCode, true, function (err, result) {
      if (err) {
        console.log('err------', err);
        callback.cognitoCallback(err.message, null);
      } else {
        callback.cognitoCallback('accountConfirmed', result);
      }
    });
  }

  resendCode(username: string, callback: CognitoCallback): void {
    let userData = {
      Username: username,
      Pool: this.getUserPool()
    };

    let cognitoUser = new CognitoUser(userData);

    cognitoUser.resendConfirmationCode(function (err, result) {
      if (err) {
        callback.cognitoCallback(err.message, null);
      } else {
        callback.cognitoCallback(null, result);
      }
    });
  }

  newPassword(newPasswordUser: any, callback: CognitoCallback): void {
    // Get these details and call
    // cognitoUser.completeNewPasswordChallenge(newPassword, userAttributes, this);
    let authenticationData = {
      Username: newPasswordUser.username,
      Password: newPasswordUser.existingPassword,
    };
    let authenticationDetails = new AuthenticationDetails(authenticationData);

    let userData = {
      Username: newPasswordUser.username,
      Pool: this.getUserPool()
    };

    let cognitoUser = new CognitoUser(userData);
    cognitoUser.authenticateUser(authenticationDetails, {
      newPasswordRequired: function (userAttributes, requiredAttributes) {
        // User was signed up by an admin and must provide new
        // password and required attributes, if any, to complete
        // authentication.

        // the api doesn't accept this field back
        delete userAttributes.email_verified;
        cognitoUser.completeNewPasswordChallenge(newPasswordUser.password, requiredAttributes, {
          onSuccess: function (result) {
            callback.cognitoCallback(null, userAttributes);
          },
          onFailure: function (err) {
            callback.cognitoCallback(err, null);
          }
        });
      },
      onSuccess: function (result) {
        callback.cognitoCallback(null, result);
      },
      onFailure: function (err) {
        callback.cognitoCallback(err, null);
      }
    });
  }

  confirmMFA(username, mfaCode: string, callback: CognitoCallback) {
    
    let userData = {
      Username: username,
      Pool: this.getUserPool()
    };

    let cognitoUser = new CognitoUser(userData);
    cognitoUser["Session"] = localStorage.getItem('tempMF');
    let self = this;

    cognitoUser.sendMFACode(mfaCode, {
      onSuccess: function (session: CognitoUserSession) {
        localStorage.removeItem('tempMF');

        let creds = self.buildCognitoCreds(session.getIdToken().getJwtToken());

        AWS.config.credentials = creds;

        let clientParams: any = {};
        if (environment.sts_endpoint) {
          clientParams.endpoint = environment.sts_endpoint;
        }

        let sts = new STS(clientParams);
        sts.getCallerIdentity(function (err, data) {
          callback.cognitoCallback('loginSuccess', session);
        });

      },

      onFailure: function (err) {
        localStorage.removeItem('tempMF');
        callback.cognitoCallback('MFAError', err);
      }
    });
  }

  getUserAttributes(callback: CognitoCallback) {
    let cognitoUser = this.getCurrentUser();
    if (cognitoUser != null) {
      cognitoUser.getSession(function (err, session) {
        cognitoUser.getUserAttributes(function (errr, result) {
          if (errr) {
            callback.cognitoCallback('Session Error', errr);
          } else {
            callback.cognitoCallback('User Attr', result);
          }
        });
      });
    }
    else {
      callback.cognitoCallback('Session Error', 'User not valid');
    }
  }

  changePassword(currentPassword, newPassword, callback: CognitoCallback) {
    let cognitoUser = this.getCurrentUser();

    if (cognitoUser != null) {
      cognitoUser.getSession(function (errr, session) {

        cognitoUser.changePassword(currentPassword, newPassword, function (err, result) {
          if (err) {
            callback.cognitoCallback('Error', err);
            return;
          }
          callback.cognitoCallback(result, null);
        });

      });
    }

  }

  updateAttributes(attributeList, callback: CognitoCallback) {

    let cognitoUser = this.getCurrentUser();

    if (cognitoUser != null) {
      cognitoUser.getSession(function (err, session) {

        cognitoUser.updateAttributes(attributeList, function (err, result) {
          if (err) {
            callback.cognitoCallback('Error', err);
            return;
          }
          callback.cognitoCallback('User Attr Updated', result);
        });

      });
    }
    else {
      callback.cognitoCallback('Session Error', 'User not valid');
    }
  }

  s3list(orgId, caseId, maxObjects, callback: CognitoCallback) {
    let cognitoUser = this.getCurrentUser();

    if (cognitoUser != null) {
      cognitoUser.getSession(function (err, result) {
        if (result) {
          AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: environment.identityPoolId,
            Logins: {
              [environment.loginKey]: result.getIdToken().getJwtToken()
            }
          });
        }
      });
    }

    AWS.config.region = environment.region;

    let bucketName = environment.bucket;
    let s3bucket = new S3();

    let params = {
      Bucket: bucketName,
      MaxKeys: maxObjects,
      Prefix: orgId + '/' + caseId
    };

    s3bucket.listObjectsV2(params, function (err, data) {
      if (err) {
        callback.cognitoCallback('LISTERROR', null);
      } // an error occurred
      else { callback.cognitoCallback('LIST', data); } // successful response
    });
  }

  s3get(org, id, file, callback: CognitoCallback, trigger, attempt) {
    let cognitoUser = this.getCurrentUser();

    if (cognitoUser != null) {
      cognitoUser.getSession(function (err, result) {
        if (result) {
          AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: environment.identityPoolId,
            Logins: {
              [environment.loginKey]: result.getIdToken().getJwtToken()
            }
          });

        }
      });
    }

    AWS.config.region = environment.region;

    let bucketName = environment.bucket;
    let s3bucket = new S3();

    let params = {
      Bucket: bucketName,
      Key: org + '/' + id + '/' + file
    };

    s3bucket.getObject(params, function (err, data) {
      if (err) {
        callback.cognitoCallback('FILEERROR', {
          org: org,
          id: id,
          file: file,
          trigger: trigger,
          attempt: attempt + 1
        });
      } else {
        callback.cognitoCallback(trigger == null ? 'FILE' : 'FILE ' + trigger, {
          file: file,
          data: data
        });
      }
    });

  }

  // the trigger is for special uploads when you need to know it was a certain form rather than just any upload
  s3upload(file, name, orgID, caseID, callback: CognitoCallback, trigger, attempt) {
    let cognitoUser = this.getCurrentUser();

    if (cognitoUser != null) {

      cognitoUser.getSession(function (err, result) {

        if (result) {

          AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: environment.identityPoolId,
            Logins: {
              [environment.loginKey]: result.getIdToken().getJwtToken()
            }
          });

        }

      });

    }

    AWS.config.region = environment.region;

    let bucketName = environment.bucket;
    let s3bucket = new S3();

    let params = {
      Bucket: bucketName,
      Key: orgID + '/' + caseID + '/' + name,
      Body: file
    };

    s3bucket.upload(params, (err, data) => {

      if (err) {
        callback.cognitoCallback('UPLOAD_ERROR', {
          org: orgID,
          id: caseID,
          file: file,
          name: name,
          trigger: trigger,
          attempt: attempt + 1
        });
      } else {
        callback.cognitoCallback(trigger == null ? 'Upload Complete' : 'Upload Complete ' + trigger, `https://s3.amazonaws.com/${bucketName}/${name}`);
      }

    });
  }

  forgetDevice(deviceKey, callback: CognitoCallback) {

    let cognitoUser = this.getCurrentUser();

    if (cognitoUser != null) {

      let extendedUser = <ExtendedCognitoUser>this.getCurrentUser();

      extendedUser.getSession(function (err, session) {
        if (err) {
          return;
        }

        extendedUser['deviceKey'] = deviceKey;

        extendedUser.forgetDevice({
          onSuccess: function (result) {
            callback.cognitoCallback('FORGET_SUCCESS', null);
          },
          onFailure: function (err) {
          }
        });
      });
    }
  }

  getRememberedDevices(callback: CognitoCallback) {

    let extendedUser = <ExtendedCognitoUser>this.getCurrentUser();

    extendedUser.getSession(function (err, session) {
      extendedUser.listDevices(60, null, {
        onSuccess: function (result) {
          callback.cognitoCallback('REMEMBERED_DEVICES', result);
        },
        onFailure: function (err) {

        }
      });

    });

  }

  refreshUserToken(): void {
    let cognitoUser = this.getCurrentUser();
    if (cognitoUser != null) {
      this.getCurrentUser().getSession(function (err, session) {
        let tokenDetails = new CognitoRefreshToken({RefreshToken: session.getRefreshToken().getToken()});
        cognitoUser.refreshSession(tokenDetails, function (err, result) {
          if(result) {
            let userDetail = JSON.parse(localStorage.getItem('userDetails'));
            userDetail["token"] = result.accessToken.jwtToken;
            localStorage.setItem('userDetails', JSON.stringify(userDetail));
            return;
          }
          else {
            console.log(err);
            return;
          }
        });
      });
    } 
  }
}



// WEBPACK FOOTER //
// ./src/app/main/shared/services/cognito.service.ts